<template>
  <div id="content">
    <h1>Notificações</h1>

    <select>
      <option>Últimos 7 dias</option>
      <option>Últimos mês</option>
      <option>Último ano</option>
      <option>Todas</option>
    </select>

    <Notification :notifications="notifications" />
  </div>
</template>

<script>
import Notification from "@/components/Layout/Notification.vue"

export default {
    name: "TeacherNotifications",
    components: {
        Notification
    },
    data() {
        return {
            notifications: [
                {
                    name: "Luiz Carlos",
                    course: "Adobe InDesign CC 2020",
                    content: 'Uma pergunta comum que a maioria dos novos artistas digitais se pergunta antes de começar a criar é "Photoshop ou Illustrator?"',
                    date: "04/03/2021",
                    hour: "17:55"
                },
                {
                    name: "Renato Novaes",
                    course: "VueJs v4.0",
                    content: 'Versão 4 tem previsão de lançar a stable?',
                    date: "17/05/2021",
                    hour: "10:50"
                },
            ]
        }
    }
}
</script>

<style scoped lang="scss">
h1 {
    font-weight: 700;
    font-size: 3.125rem;
    color: #3A3B3F;
    line-height: 58px;
    letter-spacing: 1px;
}

select {
    margin: 48px 0 20px 0;
    border: 1px solid #C6CBD4;
    padding: 9px 10px;
    background: transparent;
    font-family: 'Roboto' sans-serif;
    color: #8290A9;
    border-radius: 4px;
}

@media (max-width: 768px) {
    h1 {
        font-size: 30px;
    }

    select {
        display: none;
    }
}
</style>